import { Preferences } from '@capacitor/preferences';
import { LoggedInUser } from '../interfaces/auth.interface';
import { ILanguage } from '../config/i18n/common';
import { Company } from '../interfaces/company.interface';

export const setUserStorage = async (userData: LoggedInUser | null): Promise<void> => {
  try {
    await Preferences.set({ key: 'user', value: JSON.stringify(userData) });
  } catch (e) {
    console.error('Error while saving user data');
  }
};

export const getUserStorage = async (): Promise<LoggedInUser | null> => {
  try {
    const res = await Preferences.get({ key: 'user' });
    return res?.value ? JSON.parse(res.value) : null;
  } catch (e) {
    console.error('Error while getting user data');
    return null;
  }
};

export const setLanguageStorage = async (language: ILanguage): Promise<void> => {
  try {
    await Preferences.set({ key: 'language', value: JSON.stringify(language) });
  } catch (e) {
    console.error('Error while saving language data');
  }
};

export const getLanguageStorage = async (): Promise<ILanguage | null> => {
  try {
    const res = await Preferences.get({ key: 'language' });
    return res?.value ? JSON.parse(res.value) : null;
  } catch (e) {
    console.error('Error while getting language data');
    return null;
  }
};

export const setSelectedCompanyStorage = async (data: Company | null): Promise<void> => {
  try {
    await Preferences.set({ key: 'selectedCompany', value: JSON.stringify(data) });
  } catch (e) {
    console.error('Error while saving user data');
  }
};

export const getSelectedCompanyStorage = async (): Promise<Company | null> => {
  try {
    const res = await Preferences.get({ key: 'selectedCompany' });
    return res?.value ? JSON.parse(res.value) : null;
  } catch (e) {
    console.error('Error while getting user data');
    return null;
  }
};

export const getSelectedCompanyId = async (): Promise<string> => {
  const company = await getSelectedCompanyStorage();

  return company?.id || '';
};

export const clearStorage = async () => {
  try {
    await Preferences.clear();
  } catch {
    console.log('ERROR WHILE CLEARING STORAGE')
  }
};